<template>
  <!-- 表单-修改密码 -->
  <el-dialog title :visible.sync="dialog.show" width="550px" top="50px" modal :close-on-click-modal="false" :append-to-body="true">
    <div slot="title" class="header-title"><span style="color: #000;">更改密码</span></div>
    <el-form :model="formData" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="原密码" prop="initPasswd"><el-input size="small" v-model="formData.initPasswd" type="password" placeholder="请输入原密码"></el-input></el-form-item>
      <el-form-item label="新的密码" prop="password"><el-input size="small" v-model="formData.password" type="password" placeholder="请输入新密码"></el-input></el-form-item>
      <el-form-item label="重复新密码" prop="repeatPassword"><el-input size="small" v-model="formData.repeatPassword" type="password" placeholder="请重复输入新密码"></el-input></el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取 消</el-button>
      <el-button type="primary" @click="submitForm" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { changePW } from '@/api/rbac';
  export default{
    name:'ChangePasswordForm',
    props:['dialog'],
    data(){
      const confirmPass = (rule, value, callback) => {
        if (value) {
          if (this.formData.password !== value) {
            callback(new Error('两次输入的密码不一致'));
          } else {
            callback();
          }
        } else {
          callback(new Error('请再次输入密码'));
        }
      };
      return{
        formData: {initPasswd: null,password: null,repeatPassword: null},
        rules: {
          initPasswd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
          password: [
            { required: true, message: '请输入新密码1', trigger: 'blur' }, 
            { min: 8, max: 20, message: '长度在 8 到 20 个字符', trigger: 'blur' },
            {pattern:/(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,}/,message:'密码必须包含大小写字母、数字、特殊字符，8-20个字符',trigger: 'blur'}],
          repeatPassword: [{ required: true, validator: confirmPass, trigger: 'blur' }]
        },
        current_user:{},
      }
    },
    methods:{
      async logout() {
        await this.$store.dispatch('logout');
        this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        location.reload()
      },
      submitForm() {
        let _this = this;
        _this.$refs['form'].validate(valid => {
          if (valid) {
            _this.loading = true;
            _this.formData.id = _this.current_user.id;
            changePW(this.formData).then(res => {
              _this.$message({
                message: res.msg || res.text,
                type: res.code == '200' ? 'success' : 'error'
              });
              _this.close();
              if (res.code == '200') {
                _this.logout();
              }
            });
          }
        });
      },
      close() {
        this.dialog.show = false;
      },
    },
    mounted() {
      this.current_user = this.$store.state.user;
    }
  }
</script>

<style>
</style>
